import { SyntheticEvent, useState } from 'react';
import { isSmartPhone } from '../../../../utilities/helper';
import EarningHistoryMWeb from './index_mWeb';
import EarningHistoryWeb from './index_web';

const EarningHistory = () => {
  const [routes] = useState([
    { key: 'Bonus_Wallet', title: 'Bonus Wallet' },
    { key: 'iGamio_Wallet', title: 'iGamio Wallet' }
  ]);
  const [activeTab, setActiveTab] = useState(0);
  const onChangeIndex = (index = 0) => {
    setActiveTab(index);
  };
  const onChangeTab = (_event: SyntheticEvent, activeTab: number) => {
    setActiveTab(activeTab);
  };
  return (
    <>
      {isSmartPhone ? (
        <EarningHistoryMWeb
          routes={routes}
          activeTab={activeTab}
          onChangeIndex={onChangeIndex}
          onChangeTab={onChangeTab}
        />
      ) : (
        <EarningHistoryWeb
          routes={routes}
          activeTab={activeTab}
          onChangeIndex={onChangeIndex}
          onChangeTab={onChangeTab}
        />
      )}
    </>
  );
};
export default EarningHistory;
